import 'babel-polyfill'
import Vue from 'vue'
import http from './http/index'
import commonUtils from '@/utils/commonUtils'
import commonConfig from '@/utils/commonConfig'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
// import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'
// import { uniLayerGroupMonochrome, uniCarWash } from 'vue-unicons/dist/icons'
//
// Unicon.add([uniLayerGroupMonochrome, uniCarWash])

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import ycNoContent from '@/components/commonComponents/yc-no-content'

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

// set ElementUI lang to EN
// Vue.use(Unicon)
Vue.use(ElementUI)
Vue.component('yc-no-content',ycNoContent)


// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.http = http
Vue.prototype.$commonUtils = commonUtils
Vue.prototype.$commonConfig = commonConfig

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
